import { render } from "./Bakers.vue?vue&type=template&id=05dfece0&scoped=true"
import script from "./Bakers.vue?vue&type=script&lang=js"
export * from "./Bakers.vue?vue&type=script&lang=js"

import "./Bakers.vue?vue&type=style&index=0&id=05dfece0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05dfece0"]])

export default __exports__